import { SITE_NAME, SITE_URL } from "@/lib/metadata";
import { ORG_CONTACT_EMAIL, SOCIAL_LINKS } from "@/lib/site-config";
import type { FaqItem } from "@/components/sections/FaqSection";

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/icons/icon-512.png`,
    sameAs: SOCIAL_LINKS.map((s) => s.href),
    address: {
      "@type": "PostalAddress",
      addressLocality: "Istanbul",
      addressCountry: "TR",
    },
    contactPoint: {
      "@type": "ContactPoint",
      email: ORG_CONTACT_EMAIL,
      contactType: "customer service",
      availableLanguage: ["tr", "en"],
    },
  } as const;
}

export function webSiteSchema(locale: string) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: `${SITE_URL}/${locale}`,
    inLanguage: locale,
  } as const;
}

export function faqSchema(items: ReadonlyArray<FaqItem>) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  } as const;
}

// Inline JSON-LD payload as a string suitable for
// `<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }}>`.
export function jsonLdString(value: unknown): string {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}
